import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight, 
  faCookie, 
  faInfoCircle, 
  faServer, 
  faTable, 
  faNetworkWired, 
  faCog, 
  faGlobe, 
  faShieldAlt, 
  faCalendarAlt, 
  faEnvelope 
} from "@fortawesome/free-solid-svg-icons";


const Politicacookies = () => {
  return (
 
     <div className="general-container-footer-info-ab">
                <div className="info-footer-container-ab">
          
                  <section className='section-about-1'>
                      <div>
                          <h3 className='align-about-ab'>
            <span className='acasa-about-footer'>Acasa</span>
            <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
          
            <span className='color-despre'>Politica de Cookie-uri</span>
          </h3>
                      </div>
                    
                    
                  </section>


                     <div className='tittle-ab-top'>
                        <h4>Politica de Cookie-uri</h4>
                    </div>
          
                  
          
             
          {/* Introducere */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCookie} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Politica de cookie-uri</h4>
    <p>
      Aceasta politică explică ce sunt cookie-urile, ce tipuri utilizăm pe platforma ContaLearn și cum poți gestiona preferințele tale legate de acestea.
      Politica este conformă cu Regulamentul General privind Protecția Datelor (GDPR) și legislația românească aplicabilă.
    </p>
    <p><strong>Ultima actualizare:</strong> 18 decembrie 2025</p>
  </div>
</section>

{/* Ce sunt cookie-urile */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Ce sunt cookie-urile?</h4>
    <p>
      Cookie-urile sunt fișiere mici de text stocate pe computerul, tableta sau telefonul tău atunci când accesezi un site.
      Ele sunt utilizate pentru a face site-urile să funcționeze corect, pentru a reține preferințele tale și pentru a ne ajuta să îmbunătățim performanța și experiența generală a utilizatorilor.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faInfoCircle} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Tipuri de cookie-uri */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faServer} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce tipuri de cookie-uri folosim?</h4>
    <ul>
      <li>✅ <strong>Cookie-uri esențiale (necesare)</strong> — Necesare pentru funcționarea corectă a platformei (ex: logare, sesiune, securitate). Aceste cookie-uri nu pot fi dezactivate deoarece platforma nu ar funcționa fără ele. <em>Bază legală: Interes legitim (Art. 6(1)(f) GDPR)</em></li>
      <li>⚙️ <strong>Cookie-uri de performanță</strong> — Colectează date anonime despre modul în care este utilizată platforma pentru a îmbunătăți funcționalitatea. <em>Bază legală: Consimțământ (Art. 6(1)(a) GDPR)</em></li>
      <li>🎯 <strong>Cookie-uri de analiză și statistică</strong> — Folosite pentru a înțelege comportamentul general al utilizatorilor (ex: Google Analytics, număr de vizitatori, pagini vizitate). <em>Bază legală: Consimțământ (Art. 6(1)(a) GDPR)</em></li>
      <li>📢 <strong>Cookie-uri de marketing (opționale)</strong> — Permite afișarea de anunțuri și conținut personalizat, doar cu acordul tău explicit. <em>Bază legală: Consimțământ (Art. 6(1)(a) GDPR)</em></li>
    </ul>
  </div>
</section>

{/* Tabel detaliat cookie-uri */}
<section className='section-about-2'>
  <div className='part-text-about' style={{width: '100%'}}>
    <h4>Tabel detaliat cu cookie-urile utilizate</h4>
    <div style={{overflowX: 'auto', marginTop: '15px'}}>
      <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem'}}>
        <thead>
          <tr style={{backgroundColor: '#13b8ab', color: 'white'}}>
            <th style={{padding: '12px', textAlign: 'left', border: '1px solid #ddd'}}>Nume Cookie</th>
            <th style={{padding: '12px', textAlign: 'left', border: '1px solid #ddd'}}>Scop</th>
            <th style={{padding: '12px', textAlign: 'left', border: '1px solid #ddd'}}>Tip</th>
            <th style={{padding: '12px', textAlign: 'left', border: '1px solid #ddd'}}>Durată</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>session_id</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Menține sesiunea utilizatorului autentificat</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Esențial</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Sesiune</td>
          </tr>
          <tr style={{backgroundColor: '#f9f9f9'}}>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>auth_token</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Token de autentificare pentru securitate</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Esențial</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>30 zile</td>
          </tr>
          <tr>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>cookie_consent</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Reține preferințele tale despre cookie-uri</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Esențial</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>12 luni</td>
          </tr>
          <tr style={{backgroundColor: '#f9f9f9'}}>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>_ga</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Google Analytics - identificare utilizatori unici</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Analiză</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>2 ani</td>
          </tr>
          <tr>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>_gid</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Google Analytics - distingere între utilizatori</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Analiză</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>24 ore</td>
          </tr>
          <tr style={{backgroundColor: '#f9f9f9'}}>
            <td style={{padding: '10px', border: '1px solid #ddd'}}><strong>_gat</strong></td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Google Analytics - limitarea ratei de cereri</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>Analiză</td>
            <td style={{padding: '10px', border: '1px solid #ddd'}}>1 minut</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

{/* Cookie-uri de la terti */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faNetworkWired} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Cookie-uri de la terți</h4>
    <p>
      ContaLearn utilizează servicii de la terți care pot plasa propriile cookie-uri:
    </p>
    <ul>
      <li>📊 <strong>Google Analytics</strong> — Pentru analiza traficului și comportamentului utilizatorilor</li>
      <li>🔐 <strong>Servicii de autentificare</strong> — Google OAuth, LinkedIn Login</li>
      <li>💳 <strong>Procesatori de plăți</strong> — Stripe, PayPal (pentru tranzacții securizate)</li>
    </ul>
    <p>Aceste servicii au propriile politici de confidențialitate și cookie-uri pe care te încurajăm să le consulți.</p>
  </div>
</section>

{/* Cum poti gestiona cookie-urile */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cum poți gestiona cookie-urile?</h4>
    <p>
      La prima accesare a site-ului, vei vedea un banner prin care poți accepta sau personaliza cookie-urile.
      Ulterior, poți modifica preferințele oricând din setările browserului tău:
    </p>
    <ul>
      <li>▸ Ștergerea cookie-urilor existente</li>
      <li>▸ Blocarea cookie-urilor viitoare</li>
      <li>▸ Stabilirea de excepții pentru anumite site-uri</li>
    </ul>
    <p><strong>Atenție:</strong> Dezactivarea cookie-urilor esențiale poate afecta funcționarea normală a platformei (nu vei putea să te autentifici sau să salvezi progresul).</p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCog} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Setari browser */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faGlobe} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Gestionarea cookie-urilor în browsere</h4>
    <p>Poți gestiona sau șterge cookie-urile din setările browserului tău:</p>
    <ul>
      <li>🌐 <strong>Google Chrome:</strong> Setări → Confidențialitate și securitate → Cookie-uri și alte date ale site-urilor</li>
      <li>🦊 <strong>Mozilla Firefox:</strong> Opțiuni → Confidențialitate și securitate → Cookie-uri și date de site</li>
      <li>🧭 <strong>Safari:</strong> Preferințe → Confidențialitate → Gestionare date site-uri web</li>
      <li>🔷 <strong>Microsoft Edge:</strong> Setări → Cookie-uri și permisiuni pentru site-uri → Gestionare și ștergere cookie-uri</li>
    </ul>
    <p>Pentru informații detaliate, vizitează pagina de ajutor a browserului tău.</p>
  </div>
</section>

{/* Drepturile tale */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Drepturile tale conform GDPR</h4>
    <p>
      În conformitate cu GDPR, ai următoarele drepturi legate de prelucrarea datelor prin cookie-uri:
    </p>
    <ul>
      <li>✓ <strong>Dreptul de acces</strong> — Poți solicita informații despre cookie-urile stocate</li>
      <li>✓ <strong>Dreptul de retragere a consimțământului</strong> — Poți retrage consimțământul oricând</li>
      <li>✓ <strong>Dreptul de opoziție</strong> — Poți să te opui utilizării anumitor cookie-uri</li>
      <li>✓ <strong>Dreptul de ștergere</strong> — Poți solicita ștergerea datelor colectate prin cookie-uri</li>
    </ul>
    <p>Pentru exercitarea acestor drepturi, contactează-ne la <strong>suport@contalearn.ro</strong></p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Actualizari */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCalendarAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Actualizări ale politicii</h4>
    <p>
      Această politică poate fi modificată periodic pentru a reflecta schimbările în practicile noastre sau cerințele legislative. 
      Orice actualizare va fi publicată pe această pagină, împreună cu data ultimei modificări (vizibilă în partea de sus a paginii).
    </p>
    <p>
      Te încurajăm să verifici din când în când conținutul pentru a rămâne informat despre cum protejăm și gestionăm datele tale.
    </p>
  </div>
</section>

{/* Contact */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Contact</h4>
    <p>
      Pentru întrebări legate de cookie-uri sau de politica de confidențialitate, ne poți contacta la:<br />
      📩 <strong>suport@contalearn.ro</strong>
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

            
          
          
          
          
          
           <div className='line-about'></div>
          
               
          
                </div>
              </div>
  
  );
};

export default Politicacookies;
